<template>
    <div class="data-errors-popup">
        <h2 class="data-errors-popup__title">
            Problems with Property data
        </h2>
        <p v-if="hasErrors"
           class="data-errors-popup__message data-errors-popup__message--with-errors">
            The following problems were found with the data for this property. They must be resolved before you can continue
        </p>
        <p v-else
           class="data-errors-popup__message data-errors-popup__message--no-errors">
            No problems found with the existing data. Click OK to continue.
        </p>
        <ul class="data-errors-popup__errors">
            <li v-for="err in errors"
                :key="err"
                class="data-errors-popup__errors__error-item">
                <span class="data-errors-popup__errors__error">{{ err }}</span>
            </li>
        </ul>
        <div class="data-errors-popup__buttons --modal-buttons">
            <hh-btn class="data-errors-popup__buttons__ok"
                    :text="buttonText"
                    @click="onOkClick" />
        </div>
    </div>
</template>

<script>

import Vuex from 'vuex'

export default {
    name: 'DataErrorsPopup',

    props: {

        info: {
            type: Object,
            default: null,
        },
    },

    computed: {

        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {?PropertyAsJson}
             */
            currentProperty: stateStore => stateStore.property,

            /**
             * @param {VuexState} stateStore
             * @returns {Array<string>}
             */
            errors: stateStore => stateStore.myHome.errors,
        }),

        /**
         * @returns {string}
         */
        buttonText() {
            return this.info && this.info.buttonText
                ? this.info.buttonText
                : this.hasErrors ? 'Fix Problems' : 'OK'
        },

        /**
         * @returns {boolean}
         */
        hasErrors() {
            return this.errors && !!this.errors.length
        },

        /**
         * @returns {boolean}
         */
        needsToRedirectToFixProblems() {
            return this.info && this.info.buttonText
                ? false
                : this.hasErrors
        },
    },

    methods: {

        /**
         * Event method.
         */
        onOkClick() {
            if (this.needsToRedirectToFixProblems) {
                this.$router.push({
                    name: 'MyHomeEdit',
                    query: { id: this.currentProperty.id },
                })
            }

            this.$eventbus.$emit(this.$appevents.hideModal)
        },
    },
}
</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.data-errors-popup {
    padding-bottom: $cta-tile-breakout-single-height;

    @include bp-min-small {
        padding-bottom: 0;
    }

    @include element('message') {

        @include modifier('with-errors') {

            &:after {
                content: '…'
            }
        }
    }

    @include element('errors') {
        padding-top: 10px;

        @include element('error-item') {
            font-weight: bold;
            margin-right: 0.5rem;
        }

        @include element('error') {
            color: $error;
            font-size: 0.9rem;
            @include styled-data-list;
        }
    }

    @include element('buttons') {

        @include element('ok') {
            min-width: 120px;
        }
    }
}

</style>

